import {
  STUDIO_SEARCH_DEFAULT_SORT_BY,
  STUDIO_SEARCH_MOST_NEWEST,
  STUDIO_SEARCH_MOST_POPULAR,
  STUDIO_SEARCH_RANDOM,
} from 'constants/app';

// eslint-disable-next-line import/prefer-default-export
export const sortOptions = [
  {
    title: 'txt_sort_by_search_best_match',
    value: STUDIO_SEARCH_DEFAULT_SORT_BY,
  },
  {
    title: 'txt_sort_by_search_most_popular',
    value: STUDIO_SEARCH_MOST_POPULAR,
  },
  {
    title: 'txt_sort_by_search_newest',
    value: STUDIO_SEARCH_MOST_NEWEST,
  },
  {
    title: 'txt_sort_by_search_random',
    value: STUDIO_SEARCH_RANDOM,
  },
];
